import { Box, UnorderedList } from '@chakra-ui/react';
import BlogMenuItem from './BlogMenuItem';

export default function BlogMenu({ category }) {
  if (!category || category.length === 0) return false;

  return (
    <div>
      <Box className="links" backgroundColor="brand.900" p={{ base: '15px 0', lg: '30px 0' }}>
        <UnorderedList
          listStyleType="none"
          display="flex"
          alignItems="center"
          justifyContent="center"
          ml="0"
          borderBottom="1px solid white"
          borderTop="1px solid white"
          p="20px 0 10px 0"
          flexFlow="wrap"
        >
          {category &&
            category.length > 0 &&
            category?.map(({ id, name, path }, index) => {
              return <BlogMenuItem name={name} path={path} active={true} key={`BlogmenuItem-${index}`} />;
            })}
        </UnorderedList>
      </Box>
    </div>
  );
}
